import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-variant',
  templateUrl: './add-variant.component.html',
  styleUrls: ['./add-variant.component.scss']
})
export class AddVariantComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data, private dialogRef: MatDialogRef<AddVariantComponent>) {
    dialogRef.disableClose = true;
  }

  disableSaveButton: boolean = true;
  validationStatus: string = "Variant name length needs to be between\n 1 and maximum 100 characters long"
  ngOnInit() {
  }

  validate(name: string) {
    if (name.length > 100 || name.length < 1) {
      this.disableSaveButton = true;
    }
    else {
      this.disableSaveButton = false;
      this.data.layoutname = name;
    }
  }

  cancel() {
    return { state: false }
  }

  save() {
    return { state: true, layoutname: this.data.layoutname };
  }
}
